import React from 'react'
import { useWatch } from 'react-hook-form'
import ReactJson from 'react-json-view'

interface Props {
    /** Should be expanded on initial render. Defaults to false */
    defaultExpanded?: boolean
    /** Display only if on localhost. Defaults to true */
    localhost?: boolean
    /** Limit output to specific fields */
    name?: string
    /** Show as treeview. Defaults to true */
    treeview?: boolean
}

const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname)
/**
 * Optional live debug for react-hook-form. Must be a child of a FormProvider.
 *
 * By default, this will not render if not localhost
 *  */
export const RhfDebug: React.VFC<Props> = ({
    defaultExpanded = false,
    localhost = true,
    name,
    treeview = true,
}: Props) => {
    const disabled = localhost && !isLocalHost
    // @ts-expect-error Allow any name
    const values = useWatch({ name, disabled })

    if (disabled) {
        return <div />
    }

    if (!values) {
        // 'Did you place `<RhfDebug />` as a child of a Rhf `<FormProvider />` component?'
        return <div />
    }

    return (
        <div style={{ margin: '8px 0' }}>
            {treeview ? (
                <ReactJson
                    collapsed={!defaultExpanded}
                    name={name}
                    quotesOnKeys={false}
                    sortKeys
                    src={values}
                    theme="solarized"
                />
            ) : (
                <pre>{JSON.stringify(values, null, 4)}</pre>
            )}
        </div>
    )
}

export type { Props as RhfDebugProps }
